import { useState, useEffect } from 'react'

export function useScarcity() {
  const [copies, setCopies] = useState<number>(47)

  useEffect(() => {
    const COPIES_KEY = 'db_copies_remaining'
    const LAST_VISIT_KEY = 'db_last_visit'

    const storedCopies = localStorage.getItem(COPIES_KEY)
    const lastVisit = localStorage.getItem(LAST_VISIT_KEY)
    const now = Date.now()

    if (!storedCopies) {
      // First visit: random between 37 and 47
      const initial = Math.floor(Math.random() * (47 - 37 + 1)) + 37
      setCopies(initial)
      localStorage.setItem(COPIES_KEY, initial.toString())
      localStorage.setItem(LAST_VISIT_KEY, now.toString())
    } else {
      let currentCopies = parseInt(storedCopies, 10)

      // If they visited before, decrease by 1-3
      if (lastVisit && now - parseInt(lastVisit, 10) > 10000) {
        // Only decrease if 10s have passed to avoid rapid reloads
        const decrease = Math.floor(Math.random() * 3) + 1
        currentCopies = Math.max(5, currentCopies - decrease)
        localStorage.setItem(COPIES_KEY, currentCopies.toString())
        localStorage.setItem(LAST_VISIT_KEY, now.toString())
      }

      setCopies(currentCopies)
    }
  }, [])

  return copies
}
